module.exports = __webpack_public_path__ + "media/store/images/map-13c5725622854347af1d8e677275f1d5.svg";